module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page greyBg"
  }, [_c('pageTitle', {
    attrs: {
      "title": "提示"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "orderMsg whiteBg"
  }, [_vm._v("\n\t\t\t订单号："), _c('span', [_vm._v(_vm._s(_vm.g_PayOrder.OrderId))]), _c('br'), _vm._v("\n\t\t\t总  价："), _c('span', [_vm._v("￥ " + _vm._s(_vm._f("fomatFloat2")(_vm.g_PayOrder.Money)))])]), _vm._v(" "), (_vm.IsLoading) ? _c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsLoading),
      expression: "  IsLoading  "
    }],
    staticStyle: {
      "width": "1.2rem",
      "margin": "2.1rem auto 0 auto"
    },
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.IsLoading) ? _c('div', {
    staticClass: "main whiteBg"
  }, [_c('div', {
    staticClass: "wallet"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("我的钱包")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("K币")]), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.g_walletInfo.KCoin))]), _vm._v(" "), _c('span', [_vm._v("储值卡")]), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.g_walletInfo.StoreCardMoney) + "元")])])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("\n\t\t\t\t\t支付方式\n\t\t\t\t")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-list', {
    staticStyle: {
      "font-size": "0.3rem"
    }
  }, [_c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(1)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallStore.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("储值卡支付\n              "), _c('nobr', {
    staticClass: "Orange",
    staticStyle: {}
  }, [_vm._v(" 充1000送1000K币 ")])], 1), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(2)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1) : _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(5)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallUnionPay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("银联支付")]), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowAlipay
    }),
    on: {
      "click": function($event) {
        return _vm.goPay(3)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallAlipay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("支付宝支付")])], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowAlipay
    })
  }), _vm._v(" "), _c('mu-list-item', {
    style: ({
      display: _vm.allowWepay
    }),
    on: {
      "click": function($event) {
        return _vm.goPay(6)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/wepay.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("微信支付")])], 1), _vm._v(" "), _c('mu-divider', {
    style: ({
      display: _vm.allowWepay
    })
  }), _vm._v(" "), (_vm.loginState) ? _c('mu-list-item', {
    on: {
      "click": function($event) {
        return _vm.goPay(7)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.6rem"
    },
    attrs: {
      "slot": "left",
      "src": require("../../../static/order/SmallKB.png"),
      "backgroundColor": "transparent"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right",
      "color": "#efefef"
    },
    slot: "right"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("K币支付")])], 1) : _vm._e(), _vm._v(" "), _c('mu-divider')], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('pop', {
    attrs: {
      "display": _vm.popDisplay,
      "title": "温馨提示",
      "msg": _vm.popMsg,
      "onlyOk": _vm.popOnlyOk
    },
    on: {
      "closeHandler": _vm.closePop,
      "okHandler": _vm.closeYES
    }
  }), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666",
      "text-align": "center"
    }
  }, [_vm._v("抱歉，您尚未开通储值卡！")]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "去开通"
    },
    on: {
      "click": _vm.goOpenValue
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "countdown whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/hotel/打钩.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("预订成功，待支付")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title",
    staticStyle: {
      "float": "right",
      "font-size": "0.22rem",
      "color": "#999999",
      "padding-top": "0.08rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "0.2rem",
      "margin-bottom": "-0.02rem",
      "padding-right": "0.06rem"
    },
    attrs: {
      "src": require("../../../static/payOrder/tick.png")
    }
  }), _vm._v("\n\t\t\t\t\t全额可退，优先选房，迅捷入住\n\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43e59bbd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/payOrder/breakfastPayType.vue
// module id = 1484
// module chunks = 18